import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import TextField from "../../../../common/components/inputFields/textFields/textField";
import PopupLayout from "../../../../common/components/layouts/popupLayout/popupLayout";
import { ReactComponent as CopyIcon } from "../../../../assets/copyIcon.svg";
import "./shareLinkPopup.scss";

export default function ShareLinkPopup(props: {
  shareLink?: string;
  onClickClose?: () => void;
}) {
  return (
    <PopupLayout maxWidth="350px" onClickClose={props.onClickClose}>
      <div className="share-container">
        <h2>Share</h2>
        <div className="share-buttons-container">
          <FacebookShareButton url={props.shareLink ?? ""}>
            <FacebookIcon size={50} round />
          </FacebookShareButton>
          <LineShareButton url={props.shareLink ?? ""}>
            <LineIcon size={50} round />
          </LineShareButton>
          <TwitterShareButton url={props.shareLink ?? ""}>
            <TwitterIcon size={50} round />
          </TwitterShareButton>
          <WhatsappShareButton url={props.shareLink ?? ""}>
            <WhatsappIcon size={50} round />
          </WhatsappShareButton>
        </div>
        <h4 style={{ marginBottom: "10px" }}>Share Link</h4>
        <TextField
          placeHolder={props.shareLink}
          disabled
          isFullWidth
          padding="8px 10px"
          suffix={
            <CopyIcon
              height={20}
              width={20}
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigator.clipboard.writeText(props.shareLink ?? "")
              }
            />
          }
        />
      </div>
      <div style={{ height: "15px" }} />
    </PopupLayout>
  );
}
